import { Link } from 'react-router-dom';
import { CONTACT_INFO } from '../data';

export default function About() {
  return (
    <div className="w-full">
      {/* Page Banner */}
      <section className="relative h-[40vh] min-h-[250px] w-full overflow-hidden bg-primary-green">
        <img 
          src="https://assets.auxodev.dk/cdn-cgi/image/width=1600,quality=80,format=auto/assets/340cd821-77c4-4f44-a38b-9945cfcac15b/vedligeholdelse-garden.jpg" 
          alt="Om Haveglæde" 
          className="absolute inset-0 h-full w-full object-cover opacity-30"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-primary-green via-primary-green/50 to-transparent" />
        {/* Decorative Background Leaves */}
        <div className="absolute inset-0 pointer-events-none opacity-10 flex justify-between items-center px-12 overflow-hidden z-10">
          <i className="fa-solid fa-leaf text-white text-5xl animate-float-leaf-1 transform translate-y-12" />
          <i className="fa-solid fa-leaf text-white text-4xl animate-float-leaf-2 transform -translate-y-12 hidden md:block" />
          <i className="fa-solid fa-leaf text-white text-6xl animate-float-leaf-3 transform translate-y-6 hidden lg:block" />
        </div>
        <div className="relative z-20 mx-auto flex h-full max-w-7xl flex-col justify-end px-4 pb-12 sm:px-6 lg:px-8 text-white">
          <span className="text-xs font-bold uppercase tracking-widest text-secondary-green block mb-2">
            Mød din lokale gartner
          </span>
          <h1 className="font-display text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-5xl uppercase">
            Om Haveglæde
          </h1>
        </div>
      </section>

      {/* Main Content Section */}
      <section className="py-16 md:py-24 bg-white relative overflow-hidden">
        {/* Decorative Background Leaves */}
        <div className="absolute inset-0 pointer-events-none opacity-5 flex justify-between items-center px-12 overflow-hidden">
          <i className="fa-solid fa-leaf text-primary-green text-5xl animate-float-leaf-1 transform translate-y-12" />
          <i className="fa-solid fa-leaf text-primary-green text-4xl animate-float-leaf-2 transform -translate-y-12 hidden md:block" />
          <i className="fa-solid fa-leaf text-primary-green text-6xl animate-float-leaf-3 transform translate-y-6 hidden lg:block" />
        </div>
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="space-y-6">
              <span className="text-xs font-bold uppercase tracking-widest text-secondary-green block">
                Historien bag
              </span>
              <h2 className="font-display text-2xl md:text-3xl font-bold text-primary-green">
                Lad os hjælpe med haven
              </h2>
              <p className="font-body text-sm text-neutral-muted leading-relaxed">
                Haveglæde v/Michael Poul Ewers Petersen er din lokale og pålidelige gartner i Esbjerg og omegn. Vi udfører alt inden for professionel haveservice og anlægsarbejde med fokus på kvalitet, tillid og glade kunder.
              </p>
              <p className="font-body text-sm text-neutral-muted leading-relaxed">
                Vi har mange års erfaring med at gøre både private haver og virksomheders grønne arealer smukke og indbydende. Vi forstår, at haven er et fristed, men at tiden eller fysikken ikke altid er til at holde den, som man ønsker. Derfor står vi klar til at overtage arbejdet, så du blot kan nyde resultatet.
              </p>
              <div className="pt-4">
                <Link 
                  to="/kontakt" 
                  className="bg-primary-green hover:bg-primary-green-light text-white font-display text-xs font-bold px-8 py-4 uppercase tracking-wider transition-all duration-200 rounded-sm shadow-sm inline-block"
                >
                  Kontakt os i dag
                </Link>
              </div>
            </div>
            <div className="relative">
              <img 
                src="https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/340cd821-77c4-4f44-a38b-9945cfcac15b/room-1-51-73_1.jpg" 
                alt="Smuk dansk have" 
                className="w-full h-[400px] object-cover rounded-sm shadow-md"
              />
              <div className="absolute -bottom-6 sm:-right-2 md:right-2 lg:-right-6 bg-secondary-green text-white p-6 rounded-sm shadow-lg hidden sm:block max-w-xs">
                <p className="font-display text-sm font-bold uppercase tracking-wider mb-1">Kvalitet i fokus</p>
                <p className="text-xs text-gray-100">Vi passer din have som du gerne vil have det.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-16 md:py-24 bg-neutral-light-bg relative overflow-hidden">
        {/* Decorative Background Leaves */}
        <div className="absolute inset-0 pointer-events-none opacity-5 flex justify-between items-center px-12 overflow-hidden">
          <i className="fa-solid fa-leaf text-primary-green text-5xl animate-float-leaf-1 transform translate-y-12" />
          <i className="fa-solid fa-leaf text-primary-green text-4xl animate-float-leaf-2 transform -translate-y-12 hidden md:block" />
          <i className="fa-solid fa-leaf text-primary-green text-6xl animate-float-leaf-3 transform translate-y-6 hidden lg:block" />
        </div>
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center max-w-3xl mx-auto mb-16 space-y-4">
            <span className="text-xs font-bold uppercase tracking-widest text-secondary-green block">
              Vores værdier
            </span>
            <h2 className="font-display text-2xl md:text-3xl font-bold text-primary-green">
              Hvad kan du forvente af os?
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Value 1 */}
            <div className="bg-white p-8 rounded-sm border border-gray-100 shadow-xs space-y-4">
              <div className="w-12 h-12 rounded-full bg-secondary-green/10 flex items-center justify-center text-secondary-green text-xl">
                <i className="fa-regular fa-shield-check" />
              </div>
              <h3 className="font-display text-base font-bold uppercase tracking-wider text-primary-green">
                Pålidelighed & Tillid
              </h3>
              <p className="font-body text-xs text-neutral-muted leading-relaxed">
                Vi overholder altid vores aftaler, kommer til tiden og udfører arbejdet med stor respekt for din ejendom.
              </p>
            </div>

            {/* Value 2 */}
            <div className="bg-white p-8 rounded-sm border border-gray-100 shadow-xs space-y-4">
              <div className="w-12 h-12 rounded-full bg-secondary-green/10 flex items-center justify-center text-secondary-green text-xl">
                <i className="fa-regular fa-award" />
              </div>
              <h3 className="font-display text-base font-bold uppercase tracking-wider text-primary-green">
                Højt Fagligt Niveau
              </h3>
              <p className="font-body text-xs text-neutral-muted leading-relaxed">
                Med mange års erfaring inden for gartnerfaget sikrer vi, at dine planter, hække og belægninger behandles korrekt.
              </p>
            </div>

            {/* Value 3 */}
            <div className="bg-white p-8 rounded-sm border border-gray-100 shadow-xs space-y-4 md:col-span-2 lg:col-span-1">
              <div className="w-12 h-12 rounded-full bg-secondary-green/10 flex items-center justify-center text-secondary-green text-xl">
                <i className="fa-regular fa-face-smile" />
              </div>
              <h3 className="font-display text-base font-bold uppercase tracking-wider text-primary-green">
                Glade Kunder
              </h3>
              <p className="font-body text-xs text-neutral-muted leading-relaxed">
                Vores vigtigste mål er, at du bliver glad for din have. Vi rådgiver og vejleder dig hele vejen igennem processen.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Info & Opening Hours Section */}
      <section className="py-16 bg-white relative overflow-hidden">
        {/* Decorative Background Leaves */}
        <div className="absolute inset-0 pointer-events-none opacity-5 flex justify-between items-center px-12 overflow-hidden">
          <i className="fa-solid fa-leaf text-primary-green text-5xl animate-float-leaf-1 transform translate-y-12" />
          <i className="fa-solid fa-leaf text-primary-green text-4xl animate-float-leaf-2 transform -translate-y-12 hidden md:block" />
          <i className="fa-solid fa-leaf text-primary-green text-6xl animate-float-leaf-3 transform translate-y-6 hidden lg:block" />
        </div>
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="relative overflow-hidden bg-gradient-to-br from-primary-green via-primary-green to-[#1b3a24] text-white rounded-xl p-8 md:p-12 shadow-xl border border-secondary-green/20">
            {/* Decorative Card Leaves */}
            <div className="absolute -right-10 -bottom-10 pointer-events-none opacity-10 text-secondary-green select-none">
              <i className="fa-solid fa-leaf text-[180px] animate-float-leaf-2" />
            </div>
            <div className="absolute -left-10 -top-10 pointer-events-none opacity-5 text-white select-none">
              <i className="fa-solid fa-leaf text-[140px] animate-float-leaf-1" />
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 relative z-10">
              {/* Left Column: Company Info */}
              <div className="bg-white/5 backdrop-blur-xs p-6 md:p-8 rounded-lg border border-white/10 flex flex-col justify-between space-y-6 transition-all duration-300 hover:border-secondary-green/30">
                <div>
                  <span className="text-[10px] font-bold uppercase tracking-widest text-secondary-green bg-secondary-green/10 px-2.5 py-1 rounded-full inline-block mb-4">
                    Virksomhed
                  </span>
                  <h3 className="font-display text-xl md:text-2xl font-bold uppercase tracking-wider text-white">
                    Virksomhedsoplysninger
                  </h3>
                </div>
                <div className="space-y-4 text-sm text-gray-200">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-full bg-secondary-green/15 flex items-center justify-center text-secondary-green shrink-0 border border-secondary-green/20">
                      <i className="fa-solid fa-user text-sm" />
                    </div>
                    <div>
                      <p className="text-xs text-gray-400 font-medium">Navn</p>
                      <p className="font-semibold text-white">{CONTACT_INFO.name}</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-full bg-secondary-green/15 flex items-center justify-center text-secondary-green shrink-0 border border-secondary-green/20">
                      <i className="fa-solid fa-location-dot text-sm" />
                    </div>
                    <div>
                      <p className="text-xs text-gray-400 font-medium">Adresse</p>
                      <p className="font-semibold text-white">{CONTACT_INFO.address}</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-full bg-secondary-green/15 flex items-center justify-center text-secondary-green shrink-0 border border-secondary-green/20">
                      <i className="fa-solid fa-id-card text-sm" />
                    </div>
                    <div>
                      <p className="text-xs text-gray-400 font-medium">CVR-nummer</p>
                      <p className="font-semibold text-white">CVR: {CONTACT_INFO.cvr}</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right Column: Opening Hours & Contact */}
              <div className="bg-white/5 backdrop-blur-xs p-6 md:p-8 rounded-lg border border-white/10 flex flex-col justify-between space-y-6 transition-all duration-300 hover:border-secondary-green/30">
                <div>
                  <span className="text-[10px] font-bold uppercase tracking-widest text-secondary-green bg-secondary-green/10 px-2.5 py-1 rounded-full inline-block mb-4">
                    Kontakt & Tid
                  </span>
                  <h3 className="font-display text-xl md:text-2xl font-bold uppercase tracking-wider text-white">
                    Telefontider & Kontakt
                  </h3>
                </div>
                <div className="space-y-4 text-sm text-gray-200">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-full bg-secondary-green/15 flex items-center justify-center text-secondary-green shrink-0 border border-secondary-green/20">
                      <i className="fa-solid fa-phone text-sm" />
                    </div>
                    <div>
                      <p className="text-xs text-gray-400 font-medium">Ring direkte</p>
                      <a href={`tel:${CONTACT_INFO.phoneRaw}`} className="font-semibold text-white hover:text-secondary-green transition-colors whitespace-nowrap">
                        <span className="whitespace-nowrap">{CONTACT_INFO.phone}</span>
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-full bg-secondary-green/15 flex items-center justify-center text-secondary-green shrink-0 border border-secondary-green/20">
                      <i className="fa-solid fa-envelope text-sm" />
                    </div>
                    <div>
                      <p className="text-xs text-gray-400 font-medium">Send en mail</p>
                      <a href={`mailto:${CONTACT_INFO.email}`} className="font-semibold text-white hover:text-secondary-green transition-colors whitespace-nowrap">
                        <span className="whitespace-nowrap">{CONTACT_INFO.email}</span>
                      </a>
                    </div>
                  </div>

                  <div className="pt-4 border-t border-white/10 text-xs text-gray-300 space-y-1.5">
                    <div className="flex items-center gap-2 text-gray-400">
                      <i className="fa-regular fa-clock text-secondary-green text-xs" />
                      <span className="font-medium">Åbningstider</span>
                    </div>
                    <p>{CONTACT_INFO.hours}</p>
                    <p>{CONTACT_INFO.hoursWeekend}</p>
                    <p className="text-secondary-green italic font-medium mt-1">{CONTACT_INFO.hoursMails}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
